import { render, staticRenderFns } from "./link-back.vue?vue&type=template&id=55448a36&"
import script from "./link-back.vue?vue&type=script&lang=js&"
export * from "./link-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/link-back/link-back.vue
// module id = 252
// module chunks = 0